import React, { useEffect, useState } from 'react';
import { Hero } from './components/Hero';
import { Navbar } from './components/Navbar';
import { SignupModal } from './components/SignupModal';
import { ProblemSolution } from './components/ProblemSolution';
import { Features } from './components/Features';
import { Interface } from './components/Interface';
import { Philosophy } from './components/Philosophy';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDark, setIsDark] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const toggleTheme = () => {
    setIsDark(!isDark);
  };
  // Apply dark mode class to html element
  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);
  return <div className={`relative w-full min-h-screen ${isDark ? 'dark bg-black text-white' : 'bg-white text-black'} transition-colors duration-500`} data-id="element-0">
      <Navbar openModal={openModal} isDark={isDark} toggleTheme={toggleTheme} data-id="element-1" />
      <Hero openModal={openModal} data-id="element-2" />
      <ProblemSolution data-id="element-3" />
      <Features data-id="element-4" />
      <Interface data-id="element-5" />
      <Philosophy data-id="element-6" />
      <FinalCTA openModal={openModal} data-id="element-7" />
      <Footer data-id="element-8" />
      <SignupModal isOpen={isModalOpen} onClose={closeModal} data-id="element-9" />
    </div>;
}